module.exports = __webpack_public_path__ + "static/media/falsk.07612a84.mp3";